const paginationBtnClass =
    "flex h-[25px] w-[25px] select-none items-center justify-center rounded-[5px] border border-nt-blue disabled:cursor-not-allowed disabled:opacity-40";

const SimplePagination = ({ page, totalPages, onPageChange, pageButtonCount = 2 }) => {
    if (totalPages <= 1) return null;

    const pages = Array.from({ length: totalPages }, (_, index) => index);

    const isPageVisible = (index) =>
        (page - index < pageButtonCount && page + pageButtonCount > index) ||
        (page === totalPages - 1 && page - pageButtonCount <= index) ||
        (page === 0 && index <= pageButtonCount);

    return (
        <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="text-nt-blue text-sm">
                Page <span className="font-semibold">{page + 1}</span> of{" "}
                <span className="font-semibold">{totalPages}</span>
            </div>
            <div className="flex justify-end gap-2.5">
                <button
                    type="button"
                    className={paginationBtnClass}
                    disabled={page === 0}
                    onClick={() => onPageChange(page - 1)}
                >
                    {"<"}
                </button>
                {pages.map((index) => {
                    if (!isPageVisible(index)) return null;

                    return (
                        <button
                            key={index}
                            type="button"
                            className={
                                paginationBtnClass + (page === index ? " bg-nt-blue text-white" : "")
                            }
                            onClick={() => onPageChange(index)}
                        >
                            {index + 1}
                        </button>
                    );
                })}
                <button
                    type="button"
                    className={paginationBtnClass}
                    disabled={totalPages - 1 === page}
                    onClick={() => onPageChange(page + 1)}
                >
                    {">"}
                </button>
            </div>
        </div>
    );
};

export { SimplePagination };
